import { RiMoneyDollarBoxLine } from '@remixicon/react'
import {
  Perm_Advance_View,
  Perm_MenuFinance_View,
  Perm_OfferToPay_View,
  Perm_Reimburse_View,
  Perm_CustomerDebt_View,
  Perm_CashBook_View
} from '../../app/hooks/premissionScreen'
import { createCollapseGroup, createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'

const icons = {
  RiMoneyDollarBoxLine
}

export const financeMenuItem: MenuItem[] = [
  createCollapseGroup({
    id: 'list-finance',
    title: 'Tài chính',
    icon: icons.RiMoneyDollarBoxLine,
    iconActive: icons.RiMoneyDollarBoxLine,
    premissions: Perm_MenuFinance_View,
    children: [
      createItem({
        id: 'finance-advance',
        title: 'Tạm ứng',
        url: `/${ROUTES.FINANCE}/${ROUTES.FINANCE_CHILD.ADVANCE}`,
        premissions: Perm_Advance_View
      }),
      createItem({
        id: 'finance-reimburse',
        title: 'Hoàn ứng',
        url: `/${ROUTES.FINANCE}/${ROUTES.FINANCE_CHILD.REIMBURSE}`,
        premissions: Perm_Reimburse_View
      }),
      createItem({
        id: 'finance-dntt',
        title: 'Đề nghị thanh toán',
        url: `/${ROUTES.FINANCE}/${ROUTES.FINANCE_CHILD.OFFER_TO_PAY}`,
        premissions: Perm_OfferToPay_View
      }),
      createItem({
        id: 'finance-customer-debt',
        title: 'Công nợ khách hàng',
        url: `/${ROUTES.FINANCE}/${ROUTES.FINANCE_CHILD.CUSTOMER_DEBT}`,
        premissions: Perm_CustomerDebt_View
      }),
      createItem({
        id: 'finance-cash-book',
        title: 'Sổ thu chi',
        url: `/${ROUTES.FINANCE}/${ROUTES.FINANCE_CHILD.CASH_BOOK}`,
        premissions: Perm_CashBook_View
      })
    ]
  })
]
